export const REDLIKE_STYLE = "redlike-style";
export const REDLIKE_LIGHT_STYLE = "redlike-light-style";
export const GAMMA_STYLE = "gamma-style";

// Custom styles
export const ALFA = "alfa";
export const BEVEPE = "bevepe";
export const BIOFA = "biofa";
export const CASATI = "casati";
export const COLORIS = "coloris";
export const COLOUR_GENIE = "colour-genie";
export const CONDOR = "condor";
export const CROMOLOGY = "cromology";
export const DINOVA = "dinova";
export const DROMONT = "dromont";
export const FLUGGER = "flugger";
export const GREY_STYLE = "grey-style";
export const KEIM = "keim";
export const MIA_COLORE = "mia-colore";
export const MY_COLOUR = "my-colour";
export const PCI = "pci";
export const PROFITEC = "profitec";
export const RELIUS = "relius";
export const RUSTOLEUM = "rustoleum";
export const SPS = "sps";
export const TINT_AND_GO = "tint-and-go";
export const UCIC = "ucic";
export const VITON = "viton";
export const WEBER = "weber";
export const WINTER_STYLE = "winter-style";
export const CUSTOM_STYLES = [
    ALFA,
    BEVEPE,
    BIOFA,
    CASATI,
    COLORIS,
    COLOUR_GENIE,
    CONDOR,
    CROMOLOGY,
    DINOVA,
    DROMONT,
    FLUGGER,
    GREY_STYLE,
    KEIM,
    MIA_COLORE,
    MY_COLOUR,
    PCI,
    PROFITEC,
    RELIUS,
    RUSTOLEUM,
    SPS,
    TINT_AND_GO,
    UCIC,
    VITON,
    WEBER
];
